import { useContext, useEffect, useState } from "react";
import "./App.css";
import Signup from "./components/auth/Signup";
import MainPage from "./components/Dashboard/MainPage/index";
import { AbilityContext } from "./config/acl/Can";
import { BrowserRouter, Switch, Route, withRouter } from "react-router-dom";
import { SetImage } from "./redux/auth/actions";
import "external-svg-loader/dist/svg-loader";
import { useDispatch, useSelector } from "react-redux";
import Languages from "./components/Dashboard/Routes/Languages/Languages";
import Loading from "./components/Dashboard/Loading";
import { ToastContainer } from "react-toastify";
import { isSupported } from "firebase/messaging";
// import MonitoringService from "./monitoringService";
import {
  getTokens,
  onMessageListener,
  requestFirebaseNotificationPermission,
} from "./firebaseInit";
import OCR from "./OCR";
import store from "./redux/store";
import { pusher } from "./redux/chat/constants";
import WA from "./assets/wa.mp3"
function App(props) {
  const token = store.getState()?.whatsapp?.userTokenWhatsapp;
  const user = useSelector((state) => state.auth.user);
  var lst = ""
  function isChrome() {
    // console.table(navigator?.userAgentData?.brands)
    if (navigator?.userAgentData?.brands.filter((s) => s.brand === "Google Chrome")?.length > 0 && navigator?.userAgentData?.brands.filter((s) => s.brand === "Safari")?.length === 0) {
      return true
    } else {
      return false

    }
  }

  useEffect(() => {
    // console.log("3:7 12/4/2023")
    dispatch({ type: "GET_DATA_CHA" });
    dispatch({ type: "GET-EMP-STATUES" });
  }, [token])
  const fetchedUrl = store?.getState()?.whatsapp?.fetched_url;
  useEffect(() => {
    if (!localStorage.getItem("APP_LANG")) {
      localStorage.setItem("APP_LANG", "en")
    }
    if (fetchedUrl === false) {

      let prot = window.location.protocol


      const url =
        prot + "//" + window.location.hostname +
        ":80";
      //    if (!url.includes("localhost")) {
      //  store.dispatch({
      //  type: "FETCHED_URL",
      //  payload: true,
      //  });
      //  store.dispatch({
      //    type: "FETCH_URL",
      //   payload: {
      //     base_user: url + "/accounting_backend/public",
      //   base: url,
      //  },
      // });
      //}
    }
  }, [fetchedUrl]);
  // useEffect(() => {

  //   if (user?.id) {

  //   }
  // }, [user])
  onMessageListener().then(payload => {
  
  }).catch(err => console.log('failed: ', err));
  const ability = useContext(AbilityContext);
  const loading_jobs = useSelector((state) => state.jobs.loading);
  const loading_chat = useSelector((state) => state.chat.loading);
  const loading_dept = useSelector((state) => state.department.loading);
  const loading_cur = useSelector((state) => state.currency.loading);
  const loading_com = useSelector((state) => state.companies.loading);
  const loading_cont = useSelector((state) => state.countries.loading);
  const loading_langs = useSelector((state) => state.langs.loading);
  const loading_ooff = useSelector((state) => state.offices.loading);
  const loading_les = useSelector((state) => state.liscenses.loading);
  const loading_num = useSelector((state) => state.numcats.loading);
  const loading_emp = useSelector((state) => state.employee.loading);

  const loading = () => {
    return (
      loading_emp ||
      loading_num ||
      loading_les ||
      loading_chat ||
      loading_jobs ||
      loading_dept ||
      loading_cur ||
      loading_com ||
      loading_cont ||
      loading_langs ||
      loading_ooff
    );
  };
  const dispatch = useDispatch();
  useEffect(() => {
    ability.update([
      // {
      //     subject: "USER_EDIT_CATEGORY",
      //     action: "call"
      // },
      // {
      //     subject: "USER_ADD_CATEGORY",
      //     action: "call"
      // }
      {
        subject: "all",
        action: "manage",
      },
    ]);
  }, []);
  useEffect(() => {
    dispatch({ type: "TRANSLATE", payload: localStorage.getItem('APP_LANG') ?? 'en' })
    document.querySelectorAll(".modal-icon img").forEach((img) => {
      img.addEventListener("click", function () {
        SetImage(null);
        document.getElementById("file").click();
      });
    });
  }, []);
  return (
    <>
      {isChrome() ? <BrowserRouter basename={"/"}>
        {loading() && <Loading />}
        <input
          id="file"
          type={"file"}
          accept="images"
          onChange={(e) => {
            SetImage(e.target.files[0]);
          }}
        />
        <Switch>
          <>
            <ToastContainer />
            <Route exact path={`/`} component={MainPage} />
            <Route exact path={`/ocr/test`} component={OCR} />
            <Route exact path={`/:route`} component={MainPage} />

            <Route exact path={`/auth/signup`} component={Signup} />
          </>
        </Switch>
      </BrowserRouter> :
        <div className="sorry-page">
          <svg xmlns="http://www.w3.org/2000/svg" width="102" height="27" viewBox="0 0 102 27">
            <g id="Group_7938" data-name="Group 7938" transform="translate(-30 -966)">

              <g id="Group_7937" data-name="Group 7937" transform="translate(30 976.352)">
                <path id="Path_16119" data-name="Path 16119" d="M7.645-33.909a1.207,1.207,0,0,1,.8.269.8.8,0,0,1,.324.634.984.984,0,0,1-.253.737.833.833,0,0,1-.6.246,1.574,1.574,0,0,1-.538-.111q-.047-.016-.213-.063a1.286,1.286,0,0,0-.356-.048,1.4,1.4,0,0,0-.791.254,1.849,1.849,0,0,0-.624.769,2.837,2.837,0,0,0-.245,1.229v3.757a.952.952,0,0,1-.269.69.906.906,0,0,1-.68.277.906.906,0,0,1-.68-.277.952.952,0,0,1-.269-.69v-6.547a.952.952,0,0,1,.269-.69.906.906,0,0,1,.68-.277.906.906,0,0,1,.68.277.952.952,0,0,1,.269.69v.206a2.4,2.4,0,0,1,1.043-.991A3.2,3.2,0,0,1,7.645-33.909Zm9.518,0a.92.92,0,0,1,.68.269.945.945,0,0,1,.269.7v6.705a.952.952,0,0,1-.269.69.906.906,0,0,1-.68.277.894.894,0,0,1-.672-.269,1,1,0,0,1-.277-.682,3.245,3.245,0,0,1-1.067.785,3.21,3.21,0,0,1-1.415.325,3.608,3.608,0,0,1-1.976-.563,3.942,3.942,0,0,1-1.4-1.561A4.883,4.883,0,0,1,9.843-29.5a5,5,0,0,1,.506-2.275,3.894,3.894,0,0,1,1.383-1.569,3.514,3.514,0,0,1,1.937-.563,3.654,3.654,0,0,1,1.423.277,3.735,3.735,0,0,1,1.123.705v-.016a.952.952,0,0,1,.269-.69A.906.906,0,0,1,17.163-33.909Zm-3.194,7.054a2.109,2.109,0,0,0,1.676-.753,2.8,2.8,0,0,0,.648-1.894,2.831,2.831,0,0,0-.648-1.9,2.1,2.1,0,0,0-1.676-.761,2.083,2.083,0,0,0-1.66.761,2.831,2.831,0,0,0-.648,1.9,2.822,2.822,0,0,0,.64,1.894A2.086,2.086,0,0,0,13.969-26.855Zm16.348-7.054a2.351,2.351,0,0,1,2.166.959,4.988,4.988,0,0,1,.6,2.655v4.058a.952.952,0,0,1-.269.69.906.906,0,0,1-.68.277.906.906,0,0,1-.68-.277.952.952,0,0,1-.269-.69v-4.058a2.408,2.408,0,0,0-.34-1.371,1.34,1.34,0,0,0-1.194-.5,1.8,1.8,0,0,0-1.383.531,1.881,1.881,0,0,0-.5,1.339v4.058a.952.952,0,0,1-.269.69.906.906,0,0,1-.68.277.906.906,0,0,1-.68-.277.952.952,0,0,1-.269-.69v-4.058a2.408,2.408,0,0,0-.34-1.371,1.34,1.34,0,0,0-1.194-.5,1.8,1.8,0,0,0-1.383.531,1.881,1.881,0,0,0-.5,1.339v4.058a.952.952,0,0,1-.269.69.906.906,0,0,1-.68.277.906.906,0,0,1-.68-.277.952.952,0,0,1-.269-.69v-6.547a.952.952,0,0,1,.269-.69.906.906,0,0,1,.68-.277.906.906,0,0,1,.68.277.952.952,0,0,1,.269.69v.254a3.865,3.865,0,0,1,1.083-.975,2.733,2.733,0,0,1,1.462-.4,2.394,2.394,0,0,1,2.545,1.744,3.73,3.73,0,0,1,1.1-1.2A2.75,2.75,0,0,1,30.317-33.909Zm12.063,0a.92.92,0,0,1,.68.269.945.945,0,0,1,.269.7v6.705a.952.952,0,0,1-.269.69.906.906,0,0,1-.68.277.894.894,0,0,1-.672-.269,1,1,0,0,1-.277-.682,3.245,3.245,0,0,1-1.067.785,3.21,3.21,0,0,1-1.415.325,3.608,3.608,0,0,1-1.976-.563,3.942,3.942,0,0,1-1.4-1.561A4.883,4.883,0,0,1,35.06-29.5a5,5,0,0,1,.506-2.275,3.894,3.894,0,0,1,1.383-1.569,3.514,3.514,0,0,1,1.937-.563,3.654,3.654,0,0,1,1.423.277,3.735,3.735,0,0,1,1.123.705v-.016a.952.952,0,0,1,.269-.69A.906.906,0,0,1,42.38-33.909Zm-3.194,7.054a2.109,2.109,0,0,0,1.676-.753A2.8,2.8,0,0,0,41.51-29.5a2.831,2.831,0,0,0-.648-1.9,2.1,2.1,0,0,0-1.676-.761,2.083,2.083,0,0,0-1.66.761,2.831,2.831,0,0,0-.648,1.9,2.822,2.822,0,0,0,.64,1.894A2.086,2.086,0,0,0,39.186-26.855Zm13.6-7.054a.92.92,0,0,1,.68.269.945.945,0,0,1,.269.7v6.705a.952.952,0,0,1-.269.69.906.906,0,0,1-.68.277.894.894,0,0,1-.672-.269,1,1,0,0,1-.277-.682,3.245,3.245,0,0,1-1.067.785,3.21,3.21,0,0,1-1.415.325,3.608,3.608,0,0,1-1.976-.563,3.942,3.942,0,0,1-1.4-1.561,4.883,4.883,0,0,1-.514-2.267,5,5,0,0,1,.506-2.275,3.894,3.894,0,0,1,1.383-1.569,3.514,3.514,0,0,1,1.937-.563,3.654,3.654,0,0,1,1.423.277,3.735,3.735,0,0,1,1.123.705v-.016a.952.952,0,0,1,.269-.69A.906.906,0,0,1,52.783-33.909Zm-3.194,7.054a2.109,2.109,0,0,0,1.676-.753,2.8,2.8,0,0,0,.648-1.894,2.831,2.831,0,0,0-.648-1.9,2.1,2.1,0,0,0-1.676-.761,2.083,2.083,0,0,0-1.66.761,2.831,2.831,0,0,0-.648,1.9,2.822,2.822,0,0,0,.64,1.894A2.086,2.086,0,0,0,49.589-26.855Zm11.984-.159a.871.871,0,0,1,.632.246.835.835,0,0,1,.253.626.842.842,0,0,1-.253.618.857.857,0,0,1-.632.254H56.483a.8.8,0,0,1-.609-.262.811.811,0,0,1-.245-.563,1.392,1.392,0,0,1,.063-.452,1.672,1.672,0,0,1,.237-.42l3.763-4.882H56.625a.857.857,0,0,1-.632-.254.861.861,0,0,1-.253-.634.816.816,0,0,1,.253-.61.871.871,0,0,1,.632-.246h4.87a.807.807,0,0,1,.593.246.83.83,0,0,1,.245.61,1.492,1.492,0,0,1-.047.4,1.2,1.2,0,0,1-.221.388l-3.794,4.93Zm9.241-5.437v5.31a1.137,1.137,0,0,0,.221.816.806.806,0,0,0,.585.214.917.917,0,0,0,.237-.04.889.889,0,0,1,.221-.04.314.314,0,0,1,.245.119.411.411,0,0,1,.1.277.435.435,0,0,1-.253.373,1.153,1.153,0,0,1-.6.151,3.283,3.283,0,0,1-.759-.079,1.2,1.2,0,0,1-.64-.476,2.075,2.075,0,0,1-.308-1.268v-5.358H68.712a.455.455,0,0,1-.324-.127.418.418,0,0,1-.134-.317.418.418,0,0,1,.134-.317.455.455,0,0,1,.324-.127h1.154V-35.1A.463.463,0,0,1,70-35.439a.46.46,0,0,1,.34-.135.46.46,0,0,1,.34.135.463.463,0,0,1,.134.341v1.76H72.4a.413.413,0,0,1,.308.143.452.452,0,0,1,.134.317.4.4,0,0,1-.126.309.444.444,0,0,1-.316.119Zm10.925,2.663a.431.431,0,0,1-.142.325.468.468,0,0,1-.332.135H75.289a3.671,3.671,0,0,0,.387,1.7,2.931,2.931,0,0,0,1.107,1.189,3.216,3.216,0,0,0,1.7.436,2.869,2.869,0,0,0,1.36-.317,2.8,2.8,0,0,0,.964-.808.534.534,0,0,1,.332-.143.393.393,0,0,1,.285.127.4.4,0,0,1,.126.285.47.47,0,0,1-.158.333,3.981,3.981,0,0,1-1.273,1.015,3.482,3.482,0,0,1-1.621.4,4.321,4.321,0,0,1-2.15-.523A3.7,3.7,0,0,1,74.893-27.1a4.429,4.429,0,0,1-.522-2.18,4.81,4.81,0,0,1,.514-2.275,3.711,3.711,0,0,1,1.368-1.49,3.461,3.461,0,0,1,1.818-.515,3.715,3.715,0,0,1,1.779.444,3.506,3.506,0,0,1,1.352,1.3A3.928,3.928,0,0,1,81.739-29.787Zm-3.668-2.853a2.645,2.645,0,0,0-1.7.634,2.94,2.94,0,0,0-1,1.823h5.391v-.127a2.5,2.5,0,0,0-.474-1.244,2.575,2.575,0,0,0-.988-.808A2.86,2.86,0,0,0,78.071-32.641Zm9.518-.919a5.485,5.485,0,0,1,1.383.166A3,3,0,0,1,90-32.942a.788.788,0,0,1,.387.618.484.484,0,0,1-.119.317.366.366,0,0,1-.292.143.489.489,0,0,1-.261-.063,1.309,1.309,0,0,1-.229-.19,1.569,1.569,0,0,0-.4-.3,2.623,2.623,0,0,0-.624-.182,4.583,4.583,0,0,0-.83-.071,2.967,2.967,0,0,0-1.589.444,3.144,3.144,0,0,0-1.13,1.2,3.478,3.478,0,0,0-.411,1.68,3.658,3.658,0,0,0,.4,1.712,3.009,3.009,0,0,0,1.1,1.2A2.984,2.984,0,0,0,87.6-26a3.492,3.492,0,0,0,.909-.1,3.434,3.434,0,0,0,.672-.269,3.37,3.37,0,0,0,.379-.285,1.5,1.5,0,0,1,.221-.166.4.4,0,0,1,.206-.055.39.39,0,0,1,.3.119.435.435,0,0,1,.111.309.824.824,0,0,1-.379.579,3.313,3.313,0,0,1-1.043.531,4.618,4.618,0,0,1-1.47.222,3.883,3.883,0,0,1-2.055-.547,3.728,3.728,0,0,1-1.4-1.514,4.672,4.672,0,0,1-.5-2.172,4.465,4.465,0,0,1,.506-2.116,3.93,3.93,0,0,1,1.423-1.53A3.9,3.9,0,0,1,87.589-33.56Zm8.711.127a2.515,2.515,0,0,1,2.119.9,3.651,3.651,0,0,1,.7,2.306v4.486a.462.462,0,0,1-.134.341.46.46,0,0,1-.34.135.46.46,0,0,1-.34-.135.463.463,0,0,1-.134-.341v-4.486a2.681,2.681,0,0,0-.49-1.672,1.806,1.806,0,0,0-1.534-.642,2.627,2.627,0,0,0-1.257.317,2.656,2.656,0,0,0-.957.848,1.994,1.994,0,0,0-.364,1.149v4.486a.463.463,0,0,1-.134.341.46.46,0,0,1-.34.135.46.46,0,0,1-.34-.135.463.463,0,0,1-.134-.341V-36.524a.463.463,0,0,1,.134-.341.46.46,0,0,1,.34-.135.46.46,0,0,1,.34.135.463.463,0,0,1,.134.341v4.645A3.314,3.314,0,0,1,94.751-33,3.076,3.076,0,0,1,96.3-33.433Z" transform="translate(-3.25 41.759)" fill="#404040" />
                <g id="Group_7932" data-name="Group 7932" transform="translate(43.545)">
                  <path id="Path_16118" data-name="Path 16118" d="M-.358-6.405a.142.142,0,0,1-.1-.045.142.142,0,0,1,.006-.2A13.311,13.311,0,0,1,1.489-8.1a11.217,11.217,0,0,1,2.016-1,6.867,6.867,0,0,1,2.359-.458,7.176,7.176,0,0,1,2.395.457,12.344,12.344,0,0,1,2.1,1,15.272,15.272,0,0,1,2.062,1.452.142.142,0,0,1,.014.2.142.142,0,0,1-.2.014,14.98,14.98,0,0,0-2.024-1.424A12.051,12.051,0,0,0,8.16-8.839a6.892,6.892,0,0,0-2.3-.44,6.585,6.585,0,0,0-2.261.44,10.934,10.934,0,0,0-1.964.975A13.264,13.264,0,0,0-.26-6.444.142.142,0,0,1-.358-6.405Z" transform="translate(1.309 9.562)" fill="#555" />
                  <path id="Path_19225" data-name="Path 19225" d="M.951.284a.667.667,0,1,0,.667.667A.667.667,0,0,0,.951.284M.951,0A.951.951,0,1,1,0,.951.951.951,0,0,1,.951,0Z" transform="translate(0 2.857)" fill="#555" />
                  <path id="Path_19226" data-name="Path 19226" d="M.951,0A.951.951,0,1,1,0,.951.951.951,0,0,1,.951,0Z" transform="translate(12.681 2.857)" fill="#555" />
                  <path id="Path_19226_-_Outline" data-name="Path 19226 - Outline" d="M.951.284a.667.667,0,1,0,.667.667A.667.667,0,0,0,.951.284M.951,0A.951.951,0,1,1,0,.951.951.951,0,0,1,.951,0Z" transform="translate(12.681 2.857)" fill="#555" />
                </g>
                <g id="Group_7936" data-name="Group 7936" transform="translate(95.873 0)">
                  <g id="Group_7935" data-name="Group 7935" transform="translate(0)">
                    <path id="Ellipse_321" data-name="Ellipse 321" d="M3.063.411A2.653,2.653,0,0,0,1.188,4.939,2.653,2.653,0,1,0,4.939,1.188,2.635,2.635,0,0,0,3.063.411m0-.411A3.063,3.063,0,1,1,0,3.063,3.063,3.063,0,0,1,3.063,0Z" transform="translate(0 0)" fill="#555" />
                    <path id="Path_16096" data-name="Path 16096" d="M5.531-25.429a.222.222,0,0,1,.066.073.178.178,0,0,1,.025.089.149.149,0,0,1-.056.129.22.22,0,0,1-.135.041A.249.249,0,0,1,5.3-25.13a.517.517,0,0,1-.2-.228,1.073,1.073,0,0,1-.079-.465.369.369,0,0,0-.124-.307.5.5,0,0,0-.324-.1H3.731v.933a.207.207,0,0,1-.05.143.164.164,0,0,1-.129.056.245.245,0,0,1-.164-.058A.179.179,0,0,1,3.32-25.3V-27.8a.192.192,0,0,1,.058-.141A.192.192,0,0,1,3.519-28H4.685a.794.794,0,0,1,.411.11.826.826,0,0,1,.3.3.847.847,0,0,1,.112.433.809.809,0,0,1-.124.433.8.8,0,0,1-.319.3.611.611,0,0,1,.243.22.656.656,0,0,1,.1.328,2.3,2.3,0,0,0,.037.321A.179.179,0,0,0,5.531-25.429Zm-.854-1.145a.358.358,0,0,0,.2-.083.541.541,0,0,0,.151-.2.673.673,0,0,0,.058-.284.494.494,0,0,0-.122-.338.381.381,0,0,0-.3-.139H3.731v1.045Z" transform="translate(-1.422 29.62)" fill="#555" />
                  </g>
                </g>
              </g>
            </g>
          </svg>
          <div className="sorry-label">Please use Google chrome browser</div>
          <div className="sorry-label">رجاءً قم باستخدام متصفح غوغل كروم</div>
        </div>}
    </>

  );
}

export default App;
